export default __webpack_public_path__ + "static/media/kaggle.4230fd90.png";